var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		!_vm.removeContainer && 'vc-container',
		_vm.padding && 'vc-container--padding',
		_vm.hasHeight && 'vc-container--height',
		_vm.hasHeight80 && 'vc-container--height80'
	]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }